import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilterObject, SortObject } from '@bludata/hook-usetableloader';

export interface LaboratorioSliceState {
  page: number;
}

const initialState: LaboratorioSliceState = {
  page: 1,
};

export const LaboratorioSlice = createSlice({
  name: 'laboratorio',
  initialState,
  reducers: {
    setPage(state: LaboratorioSliceState, action: PayloadAction<number>) {
      state.page = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setPage } = LaboratorioSlice.actions;

export const getJsonOrdinamentoLaboratorio = (
  ordinamento: number
): SortObject[] => {
  const arrayOrdinamento = [];

  if (ordinamento === 0) {
    arrayOrdinamento.push({
      property: 'priorita',
      direction: 'DESC',
    });
    arrayOrdinamento.push({
      property: 'data',
      direction: 'ASC',
    });
  }

  if (ordinamento === 1) {
    arrayOrdinamento.push({
      property: 'data',
      direction: 'ASC',
    });
    arrayOrdinamento.push({
      property: 'priorita',
      direction: 'DESC',
    });
  }

  if (ordinamento === 2) {
    arrayOrdinamento.push({
      property: 'priorita',
      direction: 'DESC',
    });
    arrayOrdinamento.push({
      property: 'dataConsegna',
      direction: 'DESC',
    });
  }

  if (ordinamento === 3) {
    arrayOrdinamento.push({
      property: 'dataConsegna',
      direction: 'DESC',
    });
    arrayOrdinamento.push({
      property: 'priorita',
      direction: 'DESC',
    });
  }

  return arrayOrdinamento;
};

export const getJsonFiltriLaboratorio = (
  filtri: {
    priorita: number;
    tipoMontaggio: string;
    statoLavorazione: number;
    statoLab: number;
  },
  Filiale: any
): FilterObject[] => {
  const arrayFilters: FilterObject[] = [
    {
      property: 'filiale',
      operator: '=',
      value: Filiale,
    },
  ];

  if (filtri.priorita > -1) {
    arrayFilters.push({
      property: 'priorita',
      operator: '=',
      value: filtri.priorita,
    });
  }

  if (filtri.tipoMontaggio !== '0') {
    arrayFilters.push({
      property: 'codiceMontaggio',
      operator: '=',
      value: filtri.tipoMontaggio,
    });
  }

  if (filtri.statoLavorazione > 0) {
    arrayFilters.push({
      property: 'stato',
      operator: '=',
      value: filtri.statoLavorazione,
    });
  }
  if (filtri.statoLab > -1) {
    arrayFilters.push({
      property: 'statoLab',
      operator: '=',
      value: filtri.statoLab,
    });
  }

  return arrayFilters;
};

export default LaboratorioSlice.reducer;
